import React from 'react';
import TestConnectStatusService from 'services/tcStatusService';
import events from 'lib/events';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';

class TestConnectStatusBar extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {
    version: '',
    versionOutOfDate: false,
    noScannersFound: true,
    hasSocket: false,
    scanners: [],
    timer: null,
  };

  componentDidMount() {
    this.updateStatus();

    events.subscribe('testconnect.hasErrors', () => {
      this.updateStatus();
    });
  }

  updateStatus = () => {
    let tcStatus = TestConnectStatusService.getStatus();

    this.setState({
      version: tcStatus.version,
      versionOutOfDate: tcStatus.versionOutOfDate,
      noScannersFound: tcStatus.noScannersFound,
      hasSocket: tcStatus.hasSocket,
      scanners: tcStatus.scanners,
    });
  };

  render() {
    const {formatMessage} = this.props.intl;
    let versionStatus;

    if (this.state.hasSocket && this.state.version) {
      versionStatus = !this.state.versionOutOfDate ?
        <p>
          <i className='dot green-dot'/><FormattedMessage id='tc-overlay.status.tc-version'/> {this.state.version}
        </p> :
        <p>
          <i className='dot red-dot'/><FormattedMessage id='tc-overlay.status.tc-version'/> {this.state.version}
          &nbsp;
          <a href="/Content/ALEXPro.zip"><FormattedMessage id='tc-overlay.status.upgrade'/></a>
        </p>;
    } else {
      versionStatus = <p>
        <i className='dot red-dot'/><FormattedMessage id='tc-overlay.status.no-conn.tc'/>
      </p>;
    }

    let scannerStatus = !this.state.hasSocket || this.state.noScannersFound ?
      <p><i className='dot red-dot'/><FormattedMessage id='tc-overlay.status.no-scanners'/></p> :
      <p><i className='dot green-dot'/>
        <FormattedMessage id='tc-overlay.status.connected-to.scanners'
                          values={{scanners: this.state.scanners
                              .filter(s => s.toLowerCase() !== 'manual')
                              .join(` ${formatMessage({id: 'general.and'})} `)}}/>
      </p>;


    let testConnectStatus = this.state.hasSocket ?
      <p><i className='dot green-dot'/><FormattedMessage id='tc-overlay.status.connected-to.service'/></p> :
      <p><i className='dot red-dot'/><FormattedMessage id='tc-overlay.status.no-conn.service'/></p>;

    let showStatusBar = this.state.hasSocket && !this.state.noScannersFound && !this.state.versionOutOfDate;
    let style = {
      display: !showStatusBar || !this.props.showBorder ? 'block' : 'none',
    };

    return <div
      className={'row tc-status-bar ' + (this.props.showBorder ? '' : 'no-border')}
      style={style}>
      <div className='col-sm-4'>
        {versionStatus}
      </div>
      <div className='col-sm-4'>
        {testConnectStatus}
      </div>
      <div className='col-sm-4'>
        {scannerStatus}
      </div>
    </div>;
  }
}

export default injectIntl(TestConnectStatusBar);
